// file: src/utils/localForageUtils.js

import localforage from 'localforage';

// Make sure you've run: npm install localforage
localforage.config({
  name: 'myDocViewerApp', // App name
  storeName: 'filesCache', // Store name in IndexedDB
});

/**
 * Store array buffer (Uint8Array) in localForage as a Blob.
 */
export async function setFileBytesLocalForage(docId, uint8Array) {
  const blob = new Blob([uint8Array]);
  await localforage.setItem(`fileData-${docId}`, blob);
}

export async function getFileBytesLocalForage(docId) {
  const blob = await localforage.getItem(`fileData-${docId}`);
  if (!blob) return null;
  const arrayBuffer = await blob.arrayBuffer();
  return new Uint8Array(arrayBuffer);
}

/**
 * Store and retrieve JSON data by key, e.g. open files, activeFileId, pageNumber, etc.
 */
export async function setJsonLocalForage(key, value) {
  await localforage.setItem(key, JSON.stringify(value));
}

export async function getJsonLocalForage(key) {
  const raw = await localforage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Load/Save conversation from localForage for chat history
 */
export async function loadConversationFromCache(conversationId) {
  return await getJsonLocalForage(`conv-${conversationId}`);
}

export async function saveConversationToCache(conversationId, conversationMessages) {
  return await setJsonLocalForage(`conv-${conversationId}`, conversationMessages);
}

/**
 * Specialized utility functions for dialog and chat session caching
 */
export async function saveDialogDetails(dialogId, details) {
  return await setJsonLocalForage(`dialogDetails-${dialogId}`, details);
}

export async function getDialogDetails(dialogId) {
  return await getJsonLocalForage(`dialogDetails-${dialogId}`);
}

export async function saveActiveSession(dialogId, conversationId) {
  await setJsonLocalForage('activeDialogId', dialogId);
  await setJsonLocalForage('activeConversationId', conversationId);
  return { dialogId, conversationId };
}

export async function getActiveSession() {
  const dialogId = await getJsonLocalForage('activeDialogId');
  const conversationId = await getJsonLocalForage('activeConversationId');
  return { dialogId, conversationId };
}

export async function clearActiveSession() {
  await localforage.removeItem('activeDialogId');
  await localforage.removeItem('activeConversationId');
}

/**
 * Clear file data cache for a specific document
 */
export async function clearFileDataCache(docId) {
  await localforage.removeItem(`fileData-${docId}`);
}

  
  